const WORLD_MODULE_TIMEOUT_MS = 15000;
let worldModulePromise = null;
let loadedWorldModule = null;

function timeoutPromise(ms) {
  return new Promise((_, reject) => {
    const error = new Error("DoARSpace interface took too long to load.");
    error.code = "WORLD_MODULE_TIMEOUT";
    window.setTimeout(() => reject(error), ms);
  });
}

/**
 * One shared promise is used by both the DoARSpace arrival screen and the
 * World route. Once the module resolves, keep the module itself as well as the
 * promise. The route can then render it synchronously after the arrival screen
 * preloads it instead of asking React.lazy/Suspense to rediscover an already
 * resolved promise on mobile browsers.
 */
export function loadWorldModule() {
  if (loadedWorldModule) return Promise.resolve(loadedWorldModule);

  if (!worldModulePromise) {
    const importPromise = import("./WorldApp").then((module) => {
      loadedWorldModule = module;
      return module;
    });

    worldModulePromise = Promise.race([
      importPromise,
      timeoutPromise(WORLD_MODULE_TIMEOUT_MS),
    ]).catch((error) => {
      // A failed/stale chunk must be retryable after a refresh or explicit
      // retry. A late successful import may still populate loadedWorldModule.
      worldModulePromise = null;
      throw error;
    });
  }
  return worldModulePromise;
}

export function getLoadedWorldModule() {
  return loadedWorldModule;
}

export function preloadWorldModule() {
  return loadWorldModule();
}

export { WORLD_MODULE_TIMEOUT_MS };